var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.187 2.339l3.09 6.26 6.91 1.01-5 4.87 1.18 6.88-6.18-3.25-6.18 3.25 1.18-6.88-5-4.87 6.91-1.01 3.09-6.26z",
    fill: "#EFD100",
    stroke: "#D6BB00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjE4NjYgMi4zMzg2MkwxNS4yNzY2IDguNTk4NjJMMjIuMTg2NiA5LjYwODYyTDE3LjE4NjYgMTQuNDc4NkwxOC4zNjY2IDIxLjM1ODZMMTIuMTg2NiAxOC4xMDg2TDYuMDA2NTggMjEuMzU4Nkw3LjE4NjU4IDE0LjQ3ODZMMi4xODY1OCA5LjYwODYyTDkuMDk2NTggOC41OTg2MkwxMi4xODY2IDIuMzM4NjJaIiBmaWxsPSIjRUZEMTAwIiBzdHJva2U9IiNENkJCMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgStar as ReactComponent };